import React from 'react';
import Reveal from '../ui/Reveal';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const Testimonials = () => {
  const testimonials = [
    {
      quote: "Page1News didn't just get us press; they found the heart of our story and made the world care about it. True literary PR.",
      author: "CEO, Tech Innovators",
      role: "Client"
    },
    {
      quote: "Romita's guidance transformed my personal brand. She has an uncanny ability to distill complex ideas into captivating headlines.",
      author: "Bestselling Author",
      role: "Mentee"
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-5xl mx-auto px-6 lg:px-12 text-center">
        <Reveal>
          <SafeIcon icon={FiIcons.FiMessageSquare} className="text-4xl text-gold-300 mx-auto mb-8" />
          <h2 className="font-serif text-3xl md:text-5xl text-navy-900 mb-16">Words from our inner circle</h2>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 text-left">
          {testimonials.map((t, index) => (
            <Reveal key={index} delay={index * 0.2} direction="up">
              <div className="p-8 bg-offwhite border-l-4 border-gold-500 relative">
                <SafeIcon icon={FiIcons.FiFeather} className="absolute top-4 right-4 text-gray-200 text-6xl opacity-50" />
                <p className="text-gray-700 font-serif text-xl italic mb-8 relative z-10 leading-relaxed">
                  "{t.quote}"
                </p>
                <div>
                  <p className="font-semibold text-navy-900">{t.author}</p>
                  <p className="text-sm text-gray-500 uppercase tracking-wider">{t.role}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;